export enum FileShareTabType {
  Files = 'Files',
}

export interface FileShareRequestBody {
  File: File
  ExchangeSource: FileExchangeSourceEnum
  ExchangeType: FileExchangeTypeEnum
  Comments: string | undefined
}

export enum FileExchangeSourceEnum {
  OutboundAi = 1,
  Customer = 2,
}
export enum FileExchangeTypeEnum {
  Onboarding = 1,
}

export enum FileExchangeStatus {
  Undefined = 0,
  Uploaded = 1,
  Removed = 2,
  Deleted = 3,
}
